import React, { useState } from 'react';
import FilterSection from '../../components/CategoryPages/CollectiveWorship/Sections/FilterSection';
import Header from '../../components/CategoryPages/CollectiveWorship/Sections/Header';
import MainSection from '../../components/CategoryPages/CollectiveWorship/Sections/MainSection';
import withPageWrapper from '../../components/Shared/HOCs/withPageWrapper';
import useGetResources from '../../hooks/Resource/useGetResources';
import useGetSongs from '../../hooks/Song/useGetSongs';
import { returnHasTags } from '../../utils/helpers';
import { updateQuery } from '../../utils/objects';
import { buildResourceParams } from '../../utils/resource';

const CollectiveWorship = () => {
  const [displaySongs, setDisplaySongs] = useState(true);
  const [displayResources, setDisplayResources] = useState(true);
  const [displayPlaylists, setDisplayPlaylists] = useState(true);
  const [displaySongbooks, setDisplaySongbooks] = useState(true);
  const [filterParams, setFilterParams] = useState({});

  const {
    data: songs,
    fetchMore: fetchMoreSongs,
    loading: loadingSongs,
  } = useGetSongs(
    6,
    returnHasTags(
      'hasSongTags',
      'OOTA Singing School',
      'Collective Worship',
      true
    )
  );

  const {
    data: resources,
    fetchMore: fetchMoreResources,
    loading: loadingResources,
  } = useGetResources(
    2,
    returnHasTags('hasTags', 'OOTA Singing School', 'Collective Worship')
  );

  const handleFilter = (params) => {
    const resourceParams = buildResourceParams(params);
    delete resourceParams.hasSongDetail;

    fetchMoreSongs({
      variables: { ...params },
      ...updateQuery,
    });
    fetchMoreResources({
      variables: { ...resourceParams },
      ...updateQuery,
    });
    setDisplaySongs(true);
    setDisplayResources(true);
    setDisplayPlaylists(true);
    setDisplaySongbooks(true);
    setFilterParams(params);
  };

  const loading = loadingResources || loadingSongs;

  return (
    <>
      <Header />
      <FilterSection handleFilter={handleFilter} loading={loading} />
      <MainSection
        songs={songs?.songs?.data}
        resources={resources?.resources?.data}
        displayResources={displayResources}
        displaySongs={displaySongs}
        displayPlaylists={displayPlaylists}
        displaySongbooks={displaySongbooks}
        filterParams={filterParams}
      />
    </>
  );
};

export default withPageWrapper({})(CollectiveWorship);
